export function VectorRYPIcon({
  height = 13,
  color = '#fff',
}: {
  height?: number;
  color?: string;
}) {
  return (
    <svg
      width={18 * (height / 13)}
      height={height}
      viewBox="0 0 18 13"
      fill={color}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14.7893 0.0760002C16.2833 0.0760002 17.0933 0.940001 17.0933 2.344V4.954C17.0933 6.358 16.2833 7.222 14.7893 7.222H13.9253V13H12.0352V0.0760002H14.7893ZM14.5732 1.732H13.9253V5.566H14.5732C14.9872 5.566 15.2032 5.296 15.2032 4.792V2.506C15.2032 2.002 14.9872 1.732 14.5732 1.732Z"
        fill="white"
      />
      <path
        d="M9.54731 7.636V13H7.65731V7.564L5.76731 0.0760002H7.71131L8.62931 4.738H8.66531L9.58331 0.0760002H11.4553L9.54731 7.636Z"
        fill="white"
      />
      <path
        d="M2.862 7.186H2.394V13H0.504V0.0760002H3.258C4.752 0.0760002 5.562 0.904 5.562 2.308V4.792C5.562 5.53 5.202 6.124 4.518 6.358C5.256 6.682 5.562 7.312 5.562 8.068V11.29C5.562 11.956 5.598 12.586 5.76 13H3.87C3.708 12.604 3.672 11.992 3.672 11.344V8.104C3.672 7.492 3.438 7.186 2.862 7.186ZM3.672 2.506C3.672 2.002 3.456 1.732 3.042 1.732H2.394V5.566H3.042C3.456 5.566 3.672 5.296 3.672 4.792V2.506Z"
        fill="white"
      />
    </svg>
  );
}
